import { Injectable } from "@angular/core";
@Injectable({
    providedIn: 'root'
})
export class SubmittPropertyModel {
  Title = '';
  Description = '';
  PurposeId = 0;
  TypeId = 0;
  Price = 0.0;
  BedRoomId = 0;
  BathRoomId = 0;
  Area = 0;
  AreaUnitId = 0;
  CityId = 0;
  LocationId = 0;
  OtherFeatures: any;
}

@Injectable({
    providedIn: 'root'
})
export class Image {
  file?: File;
  imageUrl?: string|ArrayBuffer;
}



